import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import { FLASH_PAY_BONUS_URL } from '../../helpers/settings';

export const FlashPayBanner2 = () => {
  const { t } = useTranslation();

  const handleButtonClick = () => {
    window.open(FLASH_PAY_BONUS_URL, '_blank');
  };

  return (
    <div className={styles.container}>
      <object className={`${styles.object} ${styles.bannerBig}`}>
        <img
          src={'/ico/flash-pay-banner-big.webp'}
          alt="FlashPay"
          className={styles.banner}
        />
        <button className={styles.buttonMask} onClick={handleButtonClick}>
          К приложению
        </button>
      </object>

      <object className={`${styles.object} ${styles.bannerMed}`}>
        <img
          src={'/ico/flash-pay-banner-med.webp'}
          alt="FlashPay"
          className={styles.banner}
        />
        <button className={styles.buttonMask} onClick={handleButtonClick}>
          К приложению
        </button>
      </object>

      <object className={`${styles.object} ${styles.bannerSm}`}>
        <img
          src={'/ico/flash-pay-banner-sm.webp'}
          alt="FlashPay"
          className={styles.banner}
        />
        <button className={styles.buttonMask} onClick={handleButtonClick}>
          К приложению
        </button>
      </object>
    </div>
  );
};
